import ThemedComponent from '../../hoc/ThemedComponent';
import DashboardPage from './DashboardPage';
import { default as DashboardPage3 } from '../../themes/3/pages/dashboard/DashboardPage';

const ThemedDashboardPages = {
    default: DashboardPage,
    // 3: DashboardPage3,
};

export default ThemedComponent(ThemedDashboardPages);